<div class="page-title">
    <h1>{{ (title$ | async) ?? '' | translate }}</h1>
    <div class="title-actions"><ng-content></ng-content></div>
</div>
